import { Component, OnInit } from '@angular/core';
import { CreateEditService } from "@core/http/create-edit-service";
import { ActivatedRoute } from "@angular/router";
import { DefaultResponse } from "@core/models/Http/DefaultResponse";
import { BreadcrumbComponent } from "@shared/components/breadcrumb/breadcrumb.component";
import { FormatMobilePipe } from "@core/pipes/format-mobile.pipe";
import { MatIcon } from "@angular/material/icon";
import { Branch } from "@core/models/Branch";
import { GEMP } from "@core/models/GEMP";
import { HttpErrorResponse } from "@angular/common/http";
import { HttpMesageHandlerService } from "@core/service/http-mesage-handler";
import { NgIf, NgOptimizedImage } from "@angular/common";
import { RegionWordPipe } from "@core/pipes/region-word.pipe";
import { AuthManagementService } from "@core/service/auth-management.service";
import { UserRole } from "@core/models/Enums/UserRole";
import { environment } from "@enviroment/environment";

@Component({
  selector: 'app-branch-profile',
  standalone: true,
  imports: [
    BreadcrumbComponent,
    FormatMobilePipe,
    MatIcon,
    NgIf,
    NgOptimizedImage,
    RegionWordPipe
  ],
  templateUrl: './branch-profile.component.html',
  styleUrls: ['./branch-profile.component.scss']
})
export class BranchProfileComponent implements OnInit {
  param: string | null = null;
  gid: string | null = null;
  branchImage: string | null = null;
  branch: Branch;
  gemp: GEMP;
  currentRole: UserRole | null = null;

  constructor(
    private ecService: CreateEditService,
    private route: ActivatedRoute,
    private httpMsgHandler: HttpMesageHandlerService,
    private authManagement: AuthManagementService,
  ) {
    // Inicializa modelos
    this.branch = new Branch({} as Branch);
    this.gemp = new GEMP({} as GEMP);
    this.currentRole = this.authManagement.getRole();

    // Lee params (vienen base64)
    this.route.paramMap.subscribe(params => {
      const p = params.get('param');
      this.param = p ? atob(p) : null;

      const gid = params.get('gid');
      this.gid = gid ? atob(gid) : null;
    });
  }

  ngOnInit(): void {
    if (this.gid) this.getGEMP();
    if (this.param) this.getBranchDetails(this.param);
  }

  get showBusinessGroup(): boolean {
    const isSpain = String(environment.region ?? '').toUpperCase() === 'ES';

    if (!isSpain) {
      return true;
    }

    return ![
      UserRole.Medico,
      UserRole.Particular
    ].includes(this.currentRole as UserRole);
  }

  private getBranchDetails(idBranch: string) {
    this.ecService.getBranchByIdBranch(idBranch).subscribe({
      next: (res: DefaultResponse<Branch | Branch[]>) => {
        // El back puede regresar data como Array(1) o como objeto
        const raw = Array.isArray(res.data) ? res.data[0] : res.data;

        // Si por alguna razon viene undefined, evita romper plantilla
        this.branch = raw ? new Branch(raw as Branch) : new Branch({} as Branch);
      },
      error: (err: HttpErrorResponse) => this.httpMsgHandler.handleMsg(err)
    });
  }

  private getGEMP() {
    this.ecService.getGempbyIdGemp(this.gid!).subscribe({
      next: (res: DefaultResponse<GEMP | GEMP[]>) => {
        // Igual que arriba: soporta arreglo u objeto
        const raw = Array.isArray(res.data) ? res.data[0] : res.data;
        this.gemp = raw ? new GEMP(raw as GEMP) : new GEMP({} as GEMP);

        // Logo en base64 si existe
        const logoBase64 = (this.gemp as any)?.logoBase64 || (raw as any)?.logoBase64;
        this.branchImage = logoBase64
          ? `data:image/png;base64,${logoBase64}`
          : 'assets/images/user/imgUSer.png';
      },
      error: (err: HttpErrorResponse) => this.httpMsgHandler.handleMsg(err)
    });
  }
}
